import { Pipe, PipeTransform, type Signal, type WritableSignal } from '@angular/core';
import { asSignal } from '@helpers';

/* Si el valor indicado es un signal, lo devuelve, si no, crea uno a partir de él */

@Pipe({
  name: 'asSignal',
  standalone: true,
})
export class AsSignalPipe implements PipeTransform {
  transform<T>(value: T | null | undefined | Signal<T | null | undefined> | WritableSignal<T | null | undefined>): Signal<T | null | undefined> | WritableSignal<T | null | undefined> {
    return asSignal(value);
  }
}
